var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mt-5"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"highlighted-color1"},[_c('span',[_vm._v(_vm._s(_vm.$t('create_bank_account')))])])]),_c('div',{staticClass:"mt-3"},[_c('BankAccountCreationForm',{on:{"bank-account-created":_vm.handleCreated}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }